<template>
  <div v-if="loading" class="my-5 text-center"><i class="fa fa-spinner fa-spin"></i></div>
  <div v-else class="page profile card card-body" style="transition: none;">
    <div class="form-group row">
      <label for="lastname" class="col-sm-1 col-form-label" style="font-size: small;">{{ printLang('Global.Lastname') }}&nbsp;:&nbsp;</label>
      <div class="col-md-6 col-lg-4">
        <input id="lastname" v-model="user.lastname" type="text" class="form-control" @input="displaySaveButton('lastname')">
      </div>
      <button v-if="showSave.lastname" class="btn btn-success" @click="updateProfileData('lastname')">
        {{ printLang('MyAccount.Profile.Change') }}
      </button>
      <p v-if="success.lastname" class="text-success lead-2 d-flex align-items-center m-0">Modifié</p>
      <p v-if="error.lastname" class="text-danger lead-2 d-flex align-items-center m-0">{{ error.lastname }}</p>
    </div>
    <div class="form-group row">
      <label for="firstname" class="col-sm-1 col-form-label" style="font-size: small;">{{ printLang('Global.Firstname') }}&nbsp;:&nbsp;</label>
      <div class="col-md-6 col-lg-4">
        <input id="firstname" v-model="user.firstname" type="text" class="form-control" @input="displaySaveButton('firstname')">
      </div>
      <button v-if="showSave.firstname" class="btn btn-success" @click="updateProfileData('firstname')">
        {{ printLang('MyAccount.Profile.Change') }}
      </button>
      <p v-if="success.firstname" class="text-success lead-2 d-flex align-items-center m-0">Modifié</p>
      <p v-if="error.firstname" class="text-danger lead-2 d-flex align-items-center m-0">{{ error.firstname }}</p>
    </div>
    <div class="form-group row">
      <label for="phone" class="col-sm-1 col-form-label" style="font-size: small;">{{ printLang('Global.Phone') }}&nbsp;:&nbsp;</label>
      <div class="col-md-6 col-lg-4">
        <input id="phone" v-model="user.phone" type="text" class="form-control" @input="displaySaveButton('phone')">
      </div>
      <button v-if="showSave.phone" class="btn btn-success" @click="updateProfileData('phone')">
        {{ printLang('MyAccount.Profile.Change') }}
      </button>
      <p v-if="success.phone" class="text-success lead-2 d-flex align-items-center m-0">Modifié</p>
      <p v-if="error.phone" class="text-danger lead-2 d-flex align-items-center m-0">{{ error.phone }}</p>
    </div>
    <div class="form-group row">
      <label for="lang" class="col-sm-1 col-form-label" style="font-size: small;">{{ printLang('Global.Language') }}&nbsp;:&nbsp;</label>
      <div class="col-md-6 col-lg-4">
        <select id="lang" v-model="user.lang" class="form-control" @input="displaySaveButton('lang')">
          <option value="en">English</option>
          <option value="fr">Français</option>
        </select>
      </div>
      <button v-if="showSave.lang" class="btn btn-success" @click="updateProfileData('lang')">
        {{ printLang('MyAccount.Profile.Change') }}
      </button>
      <p v-if="success.lang" class="text-success lead-2 d-flex align-items-center m-0">Modifié</p>
      <p v-if="error.lang" class="text-danger lead-2 d-flex align-items-center m-0">{{ error.lang }}</p>
    </div>

    <div class="form-group">
      <div class="row">
        <label class="col-sm-1 col-form-label" style="font-size: small;">{{ printLang('Global.Email') }}&nbsp;:&nbsp;</label>
        <div class="col-sm-9 d-flex align-items-center">
          {{ user.email }}
          <a v-if="! changingEmail" href="#" class="ml-4" @click="changingEmail = true">
            {{ printLang('MyAccount.Profile.ChangeEmail') }}
          </a>
        </div>
      </div>
      <transition name="slide-fade">
        <form v-if="changingEmail" class="ml-6" @submit.prevent="changeEmail()">
          <div style="display:flex">
            <div>
              <div style="font-size: small;">{{ printLang('MyAccount.Profile.NewEmail') }}&nbsp;:&nbsp;</div>
              <input v-model="newEmail" type="email" class="form-control" required>
            </div>
            <div class="ml-2">
              <div style="font-size: small;">{{ printLang('Global.Password') }}&nbsp;:&nbsp;</div>
              <input v-model="checkPasswordEmail" type="password" class="form-control" required>
            </div>
          </div>
          <div class="text-danger my-2">
            <span v-if="error.email">{{ printLang("Contact.Validation.Error") }} : {{ error.email }}</span>
          </div>
          <div>
            <input type="submit" class="btn btn-success mb-2" :value="printLang('MyAccount.Profile.Change')">
          </div>
        </form>
      </transition>
    </div>
    <div class="form-group">
      <div class="d-flex align-items-center">
        <label class="col-form-label" style="font-size: small;">{{ printLang('Global.Password') }}&nbsp;:&nbsp;</label>
        <a v-if="! changingPassword" href="#" @click="changingPassword = true">
          {{ printLang('MyAccount.Profile.ChangePassword') }}
        </a>
      </div>
      <transition name="slide-fade">
        <form v-if="changingPassword" class="ml-6" @submit.prevent="changePassword()">
          <div class="row">
            <div class="col-sm-4 col-lg-3">
              <span style="font-size: small;">{{ printLang('MyAccount.Profile.OldPassword') }}&nbsp;:&nbsp;</span>
              <div>
                <input v-model="oldPassword" type="password" name="check_password" class="form-control" required>
              </div>
            </div>
            <div class="col-sm-4 col-lg-3">
              <span style="font-size: small;">{{ printLang('MyAccount.Profile.NewPassword') }}&nbsp;:&nbsp;</span>
              <div>
                <input v-model="newPassword" type="password" name="password" class="form-control" required>
              </div>
            </div>
            <div class="col-sm-4 col-lg-3">
              <span style="font-size: small;">{{ printLang('Global.PasswordConfirm') }}&nbsp;:&nbsp;</span>
              <div>
                <input v-model="confirmPassword" type="password" name="password_confirmation" class="form-control" required>
              </div>
            </div>
          </div>
          <div class="text-danger my-2">
            <span v-if="error.password">{{ printLang("Contact.Validation.Error") }} : {{ error.password }}</span>
          </div>
          <div>
            <input type="submit" class="btn btn-success mb-2" :value="printLang('MyAccount.Profile.Change')">
          </div>
        </form>
      </transition>
    </div>
    <div class="col-xs-12" style="margin-top:50px">
      <a href="#" @click.prevent="deleteAccount()">{{ printLang('MyAccount.Profile.DeleteAccount') }}</a>
      <p class="small text-muted" style="white-space: pre-line">{{ printLang('MyAccount.Profile.DeleteAccountDescription') }}</p>
      <div v-if="deleteAccountConfirmationMessage" class="notice alert alert-success">{{ printLang('MyAccount.Profile.DeleteAccountConfirmationMessage') }}</div>
    </div>
  </div>
</template>

<script>
  import apiSrv from './apiSrv';
  import { printLang } from './lang';

  export default {
    props: {
      currentpage: { type: String, default: "" },
    },
    data() {
      return {
        changingEmail: false,
        changingPassword: false,
        newEmail: null,
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
        checkPasswordEmail: null,
        deleteAccountConfirmationMessage: false,
        printLang,
        user: {
          id: null,
          lastname: null,
          firstname: null,
          phone: null,
          email: null,
          lang: null,
          password: null,
        },
        showSave: {
          lastname: false,
          firstname: false,
          phone: false,
          email: false,
          lang: false,
        },
        success: {
          lastname: false,
          firstname: false,
          phone: false,
          lang: false,
        },
        error: {
          lastname: "",
          firstname: "",
          phone: "",
          lang: "",
          email: "",
          password: "",
        },
        loading: true,
      };
    },
    mounted() {
      apiSrv.loadUser().then((user) => {
        this.user.id = user.id;
        this.user.lastname = user.lastname;
        this.user.firstname = user.firstname;
        this.user.email = user.email;
        this.user.phone = user.phone;
        this.user.lang = user.lang.substring(0, 2) || 'en';
        this.loading = false;
      });
    },
    methods: {
      displaySaveButton(field) {
        this.showSave[field] = true;
        this.success[field] = false;
        this.error[field] = false;
      },
      updateProfileData(field) {
        if (['lastname', 'firstname', 'phone', 'lang'].indexOf(field) == -1) { this.error[field] = 'invalid field'; console.error('invalid field'); return; }
        const data = {
          [field]: this.user[field],
        };
        this.showSave[field] = false;
        $.ajax({
          type: 'PUT',
          url: `${window.api.users.url}/${this.user.id}`,
          dataType: "json",
          data,
          headers: { 'X-Auth-Token': window.api_token },
        }).then(() => {
          this.success[field] = true;
          setTimeout(() => { this.success[field] = false; }, 5000);
        }).catch((errorData) => {
          const response = errorData.responseText ? JSON.parse(errorData.responseText) : {};
          this.error[field] = window.formatApiAnswer(response.message) || `Something went wrong. ${errorData.statusText}`;
          this.showSave[field] = true;
        });
      },
      changeEmail() {
        this.error.email = "";
        $.ajax({
          type: 'PUT',
          url: `${window.api.users.url}/${sessionStorage.user_id}`,
          dataType: "json",
          headers: { 'X-Auth-Token': window.api_token },
          data: {
            email: this.newEmail,
            check_password: this.checkPasswordEmail,
          },
        }).then((response) => {
          this.newEmail = "";
          this.checkPasswordEmail = "";
          this.user.email = response && response.user && response.user.email || "";
          this.changingEmail = false;
        }).catch((data) => {
          const response = data.responseText ? JSON.parse(data.responseText) : {};
          this.error.email = window.formatApiAnswer(response.message) || `Something went wrong. ${data.statusText}`;
        });
      },
      changePassword() {
        this.error.password = false;
        $.ajax({
          type: 'PUT',
          url: `${window.api.users.url}/${sessionStorage.user_id}`,
          dataType: "json",
          headers: { 'X-Auth-Token': window.api_token },
          data: {
            check_password: this.oldPassword,
            password: this.newPassword,
            password_confirmation: this.confirmPassword,
          },
        }).then(() => {
          this.oldPassword = "";
          this.newPassword = "";
          this.confirmPassword = "";
          this.changingPassword = false;
        }).catch((data) => {
          const response = data.responseText ? JSON.parse(data.responseText) : {};
          this.error.password = window.formatApiAnswer(response.message) || `Something went wrong. ${data.statusText}`;
        });
      },
      deleteAccount() {
        if (window.confirm(printLang('MyAccount.Profile.DeleteAccountConfirmation'))) {
          $("body").css("cursor", "wait");
          $.ajax({
            type: "DELETE",
            url: `${window.api.users.url}/me`,
            dataType: "json",
            headers: { 'X-Auth-Token': window.api_token },
          }).then(() => {
            this.deleteAccountConfirmationMessage = true;
            localStorage.clear();
            sessionStorage.clear();
            setTimeout(() => {
              window.location.href = "./";
            }, 5000);
          }).catch((response) => {
            console.log(response);
            if (response.status == 401) this.$emit('show-page', 'login');
          }).always(() => {
            $("body").css("cursor", "initial");
          });
        }
      },
    },
  };
</script>
